import apiConfig from "constants/apiConfig";
import axiosClient from "utils/axiosClient";

export const fetchApplications = async (hubId: string, payload: any) => {
    const response = await axiosClient.get(apiConfig.FETCH_APPLICATIONS.url.replace('<hubId>', hubId), {params: {...payload}});
    return response.data;
}